import Api from '@/common/api.helper'

export default {
  state: {
    blogs: [],
    tags: [],
    blogsDestaque: [],
    blog: null
  },
  actions: {
    loadTags ({ commit }) {
      return Api.get('/blogs/tags/all').then(response => {
        commit('setTags', response.data)
        return response
      })
    },
    loadBlogs ({ commit }, params) {
      return Api.get('/blogs/list?tag=' + params.tag.id + '&page=' + params.page).then(response => {
        commit('setBlogs', response.data)
        return response
      })
    },
    loadDestaques ({ commit }) {
      return Api.get('/blogs/featured').then(response => {
        commit('setBlogsDestaque', response.data)
        return response
      })
    },
    showBlog ({ commit }, blogId) {
      commit('setActualBlog', null)
      return Api.get(`/blogs/details/${blogId}`).then(response => {
        const data = response.data
        commit('setActualBlog', data)
        return response
      })
    }
  },
  mutations: {
    setBlogs (state, blogs) {
      state.blogs = blogs
    },
    setTags (state, tags) {
      state.tags = tags
    },
    setBlogsDestaque (state, blogsDestaque) {
      state.blogsDestaque = blogsDestaque
    },
    setActualBlog (state, blog) {
      state.blog = blog
    }
  },
  getters: {
    blogs (state) {
      return state.blogs
    },
    blog (state) {
      return state.blog
    },
    tags (state) {
      return state.tags
    },
    blogsDestaque (state) {
      return state.blogsDestaque
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/blog.js